<template>
    <div v-if="errors">
        <ul class="text-default-red">
            <template v-for="(value, index) in errors" :key="index">
                <li>{{ value }}</li>
            </template>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: ['errors'],
};
</script>
